let base = window._env_.VUE_APP_ADMIN_HOST

/**
 * 获取推广人员列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.member_name - 姓名
 * @param {string} params.member_admin_name - 账号名称
 * @param {number} params.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
export function getPromoterList (params) {
  return axios.post(`${base}/data_screen/member_admin/query`, params)
}

/**
 * 获取推广人员详情
 * @param {number} id - 推广人员ID
 * @returns {Promise} - 返回Promise对象
 */
export function getPromoterDetail (id) {
  return axios.get(`${base}/data_screen/member_admin/get_${id}`)
}

/**
 * 创建推广人员
 * @param {Object} data - 推广人员数据
 * @param {number} data.member_adminid - 账号ID
 * @param {string} data.member_name - 用户名
 * @param {number} data.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
export function createPromoter (params) {
  return axios.post(`${base}/data_screen/member_admin/create`, params)
}

/**
 * 更新推广人员
 * @param {number} id - 推广人员ID
 * @param {Object} data - 更新的推广人员数据
 * @param {number} data.member_adminid - 账号ID
 * @param {string} data.member_name - 用户名
 * @param {number} data.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
export function updatePromoter (id, params) {
  return axios.post(`${base}/data_screen/member_admin/update_${id}`, params)
}

/**
 * 删除推广人员
 * @param {number} id - 推广人员ID
 * @returns {Promise} - 返回Promise对象
 */
export function deletePromoter (id) {
  return axios.post(`${base}/data_screen/member_admin/delete_${id}`)
}

/**
 * 导出推广人员列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回Promise对象
 */
export function exportPromoterList (params) {
  return axios.post(`${base}/promoter/export`, params, {
    responseType: 'blob'
  })
}

/**
 * 获取省份列表（用于推广员）
 * @returns {Promise} - 返回Promise对象
 */
export function getPromoterProvinces () {
  return axios.post(`${base}/data_screen/query_provinces`)
}




// WEBPACK FOOTER //
// ./src/views/statistic/pages/Promoter/promoter.api.js